import angularJsUtilitiesModule from "../angularJsUtilitiesModule";

const abTestCheckConstant = {
    subjectType: {
        user: "User",
        browserTracker: "BrowserTracker"
    },
    urls: {
        checkEnrollment: "/v1/get-enrollments"
    },
    response: {
        status: {
            enrolled: "Enrolled",
            inactive: "Inactive",
            noExperiment: "NoExperiment"
        }
    },
    errorsCode: {
        unknownError: 0,
        noRobloxEnvironmentUrls: 1
    }
};

angularJsUtilitiesModule.constant("abTestCheckConstant", abTestCheckConstant);
export default abTestCheckConstant;